export default __webpack_public_path__ + "static/char-s-03-jp-660bdd9702b3813ee1d31ff310849a3f.webp";